import { createSlice } from '@reduxjs/toolkit'

const popupSlice = createSlice({
  name: 'auth',
  initialState: {
    pointer: 0,
    data: null,
    nested: {
      pointer: 0,
      data: null
    }
  },
  reducers: {
    togglePopup: (state, action) => {
      const { pointer, data } = action.payload || {}
      state.pointer = pointer || 0
      state.data = data || null
    },
    toggleChildPopup: (state, action) => {
      const { pointer, data } = action.payload || {}
      state.nested.pointer = pointer || 0
      state.nested.data = data || null
    }
  }
})
export const { togglePopup, toggleChildPopup } = popupSlice.actions

export default popupSlice.reducer
